import { createContext, useContext } from 'react';

export const NoticesContext = createContext();
export const useNoticesContext = () => {
  const context = useContext(NoticesContext);
  if (!context) {
    throw new Error(
      'NoticesContext compound components cannot be rendered outside the NoticesContext component',
    );
  }
  return context;
};
